<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useAlert } from 'dashboard/composables';
import { copyTextToClipboard } from 'shared/helpers/clipboard';
import { inboxPublicLink } from 'dashboard/helper/inboxPublicLink';
import Button from 'dashboard/components-next/button/Button.vue';

const props = defineProps({
  inbox: { type: Object, required: true },
  compact: { type: Boolean, default: false },
});

const { t } = useI18n();
const link = computed(() => inboxPublicLink(props.inbox));

const copyLink = async () => {
  await copyTextToClipboard(link.value);
  useAlert(t('INBOX_PUBLIC_LINK.COPIED'));
};
</script>

<template>
  <div v-if="link" class="flex items-center gap-1.5 min-w-0">
    <a
      v-if="!compact"
      :href="link"
      target="_blank"
      rel="noopener noreferrer"
      class="truncate text-body-main text-n-blue-11 hover:underline"
      :title="link"
    >
      {{ link }}
    </a>
    <Button
      v-tooltip.top="$t('INBOX_PUBLIC_LINK.COPY')"
      icon="i-lucide-copy"
      size="xs"
      variant="ghost"
      color="slate"
      @click="copyLink"
    />
    <a
      :href="link"
      target="_blank"
      rel="noopener noreferrer"
      class="inline-flex items-center gap-1 h-6 px-2 rounded-md text-xs font-medium whitespace-nowrap bg-n-blue-9/10 text-n-blue-11 hover:bg-n-blue-9/20 transition-colors"
    >
      <span class="i-lucide-message-circle size-3.5" />
      {{ $t('INBOX_PUBLIC_LINK.TEST_CHAT') }}
    </a>
  </div>
</template>
